import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useMemo } from 'react'
import { getPermissions } from '@/store/Permissions'
import { useSignalR } from '@/hooks/useSignalR'

export function usePermissionsForInstitutions (institutionIds, isChangeItemId) {
  const dispatch = useDispatch()
  const state = useSelector(state => state.permissions)

  const institutionIdsArray = useMemo(() => Array.isArray(institutionIds) || institutionIds === null || institutionIds === undefined ? institutionIds : [institutionIds], [institutionIds])

  const allPermissionsPresent = useCallback(() => {
    if (!institutionIds || institutionIds.length === 0) return state.institutionPermissions.hasOwnProperty(-1)
    return institutionIdsArray.every(id => state.institutionPermissions.hasOwnProperty(id))
  }, [institutionIds, institutionIdsArray, state.institutionPermissions])

  const getPerms = useCallback(async (institutionIds, isChangeItemId) => {
    await dispatch(getPermissions(institutionIds, isChangeItemId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!allPermissionsPresent()) {
      getPerms(institutionIdsArray, isChangeItemId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useSignalR('userInfoChanged', async () => {
    getPerms(institutionIdsArray, isChangeItemId)
  }, [getPerms])

  return useMemo(() => {
    const permissions = { individualEdit: 0, individualReadOnly: 0, institutionReadOnly: 0, institutionEdit: 0 }
    if (!state.institutionPermissions || state.institutionPermissions.length === 0) return permissions
    Object.entries(state.institutionPermissions).forEach(([_key, permission]) => {
      permissions.individualEdit |= permission.individualEdit
      permissions.individualReadOnly |= permission.individualReadOnly
      permissions.institutionEdit |= permission.institutionEdit
      permissions.institutionReadOnly |= permission.institutionReadOnly
    })
    return permissions
  }, [state.institutionPermissions])
}



// WEBPACK FOOTER //
// ./src/hooks/usePermissionsForInstitutions.js